import React from "react";
import ListDetailsSubLayout from "../../layout/ListDetailSubLayout";
import Equipments from "../../../components/Equipments";
import "./old-equipment.scss";

const OldEquipmentPage = () => {
  return (
    <div
      className={`oldEquipmentPage website-wrapper application-page organizationsPage`}
      style={{ minHeight: "auto" }}
    >
      <ListDetailsSubLayout
        detailsComponent={null}
        listComponent={Equipments}
      />
    </div>
  );
};

export default OldEquipmentPage;
